/**
 * Environment configuration for Fast Cortex Frontend
 *
 * This module centralizes all environment variable access and provides
 * defaults for development. All environment variables must be prefixed
 * with VITE_ to be accessible in Vite applications.
 */

// API Base URLs - auth uses /api, other endpoints use /api/v1
// In development, use relative URLs since Vite proxies to backend
// In production, use relative URLs to work with any domain
const isDev = import.meta.env.DEV
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1'
export const AUTH_BASE_URL = import.meta.env.VITE_AUTH_BASE_URL || '/api'

// Headers for an API call. Every /api/v1 route needs the sign-in token; a call that
// leaves it out gets a 401.
export const authHeaders = () => {
  const token = localStorage.getItem('token')
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  }
}

// Helper function to construct API endpoints
export const getApiEndpoint = (path) => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  return `${API_BASE_URL}/${cleanPath}`
}

// Export all configuration as a single object for convenience
export const config = {
  api: {
    baseUrl: API_BASE_URL,
    // Specific endpoint URLs
    auth: {
      token: `${AUTH_BASE_URL}/auth/token`,
      me: `${AUTH_BASE_URL}/auth/me`,
      refresh: `${AUTH_BASE_URL}/auth/refresh`
    },
    metrics: {
      profitability: `${API_BASE_URL}/metrics/profitability`,
      efficiency: `${API_BASE_URL}/metrics/efficiency`,
      costBreakdown: `${API_BASE_URL}/metrics/cost-breakdown`,
      trends: `${API_BASE_URL}/metrics/trends`
    },
    dashboards: `${API_BASE_URL}/dashboards`,
    insights: `${API_BASE_URL}/insights`,
    reports: `${API_BASE_URL}/reports`,
    export: {
      excel: `${API_BASE_URL}/export/excel`,
      pdf: `${API_BASE_URL}/export/pdf`
    }
  },
  // Other configuration can be added here
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD
}

export default config